import React, { memo } from 'react';
import UserProfileView from 'containers/UserProfile/UserProfileView';
function UserProfile() {
    return React.createElement(UserProfileView, null);
}
export default memo(UserProfile);
